module.exports = "https://cdn.dove.it/_next/static/public/assets/landings/join-our-agents-b/vantaggio_formazione.b0390c95b68cfeaa50f55342621ee534.jpg";